import React, { useEffect, useState } from "react";
import { passwordValidatorLabels } from "../../../../helpers/signUpFormConstants";
import Minus from "../../../../svgs/MinusStyled";
import { verifyErrors } from "./verifyErrors";
import Check from "../../../../svgs/FilledCheck";

type PasswordValidationLabelsType = {
  passwordHasError: boolean;
  value: string;
};

type ValidPasswordType = {
  lowerLetter: boolean;
  oneNumber: boolean;
  uppercaseLetter: boolean;
  charactersMin: boolean;
};

const PasswordValidationLabels: React.FC<PasswordValidationLabelsType> = ({
  passwordHasError,
  value,
}) => {
  const [validPassword, setValidPassword] = useState<ValidPasswordType>({
    lowerLetter: false,
    oneNumber: false,
    uppercaseLetter: false,
    charactersMin: false,
  });
  const rowLabelClassName =
    "flex justify-between items-start content-start self-stretch flex-wrap";

  useEffect(() => {
    const verifiedValidPassword = verifyErrors(value);
    setValidPassword(verifiedValidPassword);
  }, [passwordHasError, value]);

  const labelsList =
    passwordValidatorLabels &&
    passwordValidatorLabels.map(label => {
      const labelValid = validPassword[label.validator];

      return (
        <div
          key={label.copy}
          className="flex items-center gap-2 w-[193px] md:w-[160px]"
        >
          {labelValid ? (
            <Check className="w-4 h-4 shrink-0" />
          ) : (
            <Minus className="w-4 h-4 shrink-0" />
          )}
          <span
            className="text-forest-900 font-sans text-base md:text-[13px]
           not-italic font-normal leading-[160%] md:leading-[170%]"
          >
            {label.copy}
          </span>
        </div>
      );
    });

  return (
    <div className="flex flex-col gap-2">
      <div className={rowLabelClassName}>{labelsList.slice(0, 2)}</div>
      <div className={rowLabelClassName}>{labelsList.slice(2, 4)}</div>
    </div>
  );
};

export default PasswordValidationLabels;
